// extracted by mini-css-extract-plugin
export default {"main":"block_main__lIbXn","main_media":"block_main_media__SjLxH","main_info":"block_main_info__UkbiP"};